import type { ShellMessage, AppMessage } from '@harleys/shared-types';

const ALLOWED_SHELL_ORIGINS = [
  'https://pipeline.harleysplumbing.au',
  'http://localhost:53100',
];

let shellOrigin: string | null = null;

export function isFromShell(event: MessageEvent): boolean {
  return ALLOWED_SHELL_ORIGINS.includes(event.origin);
}

export function sendToShell(message: AppMessage): void {
  if (window.parent === window) {
    return;
  }
  const origin = shellOrigin ?? ALLOWED_SHELL_ORIGINS[0];
  window.parent.postMessage(message, origin);
}

export function onShellMessage(handler: (msg: ShellMessage) => void): () => void {
  const listener = (event: MessageEvent) => {
    if (!isFromShell(event)) return;
    shellOrigin = event.origin;
    handler(event.data as ShellMessage);
  };
  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
}

export function isInShell(): boolean {
  return window.parent !== window;
}
